<template>
  <b-container class="pb-4">
    <p class="support-header">
      My Pfizer Studies Support
    </p>
    <b-row>
      <b-col class="mt-3" cols="12" lg="7" md="12" sm="12" xl="7">
        <b-card class="cardStyle" style="background: #fffbfe;">
          <b-card
            v-for="(category, key, index) in categories"
            :key="index"
            class="mb-0"
            no-body
            style="border:0; background: #fffbfe;"
          >
            <b-card-header class="pl-4 pb-0" header-tag="header" style="background: #fffbfe;">
              <b-row>
                <b-col class="p-1 topic-category-title" cols="9">{{ key }}</b-col>
                <b-col class="p-0" cols="3">
                  <b-button
                    v-b-toggle="'accordion-' + index"
                    bg-white
                    class="float-right shadow-none"
                    style="border: none"
                    variant="white"
                    @click.prevent
                    ><span class="when-open"><b-icon icon="chevron-up"></b-icon></span
                    ><span class="when-closed"><b-icon icon="chevron-down"></b-icon></span>
                  </b-button>
                </b-col>
              </b-row>
            </b-card-header>
            <b-collapse :id="'accordion-' + index" :visible="index === 0">
              <b-card-body>
                <div v-for="topic in category" :key="topic['id']">
                  <b-button
                    class="py-0"
                    style="display: inline; text-decoration: underline; color: #0064C1;"
                    variant="link"
                    @click="
                      $router.push({
                        name: 'help-topic',
                        params: {
                          category: topic.category,
                          Id: topic.id,
                        },
                      })
                    "
                    >{{ topic.title }}
                  </b-button>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
          <div v-if="loading" class="text-center text-primary my-5">
            <b-spinner class="align-middle primary"></b-spinner>
            <strong>Loading ...</strong>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" lg="5" md="12" sm="12" xl="5">
        <b-row>
          <b-col class="mt-3" cols="12">
            <app-support></app-support>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import SupportInfoCard from '../utility/SupportInfoCard';
  import AppSupport from './AppSupport';
  import ContactSupport from './ContactSupport';

  export default {
    components: {
      ContactSupport,
      SupportInfoCard,
      AppSupport,
    },
    metaInfo() {
      let metaTitle = this.$appName + 'Support';
      return {
        title: metaTitle,
      };
    },
    data() {
      return {
        loading: false,
        categories: {},
      };
    },
    created() {
      this.getHelpTopic();
    },
    methods: {
      async getHelpTopic() {
        this.loading = true;
        try {
          let response = await axios.get(`/api/get-help-topics`);
          this.modifySupportData(response.data.items);
          const sortedCategoriesArray = Object.keys(this.categories)
            .sort()
            .map(categoryTitle => ({ [categoryTitle]: this.categories[categoryTitle] }));

          this.categories = Object.assign({}, ...sortedCategoriesArray);
        } catch (error) {
          console.log(error);
        }
        this.loading = false;
      },
      modifySupportData(data) {
        data.forEach(element => {
          if (element['categoryTitle'] in this.categories && element['showInSupportPage']) {
            this.categories[element['categoryTitle']].push(element);
          } else if (element['showInSupportPage']) {
            this.categories[element['categoryTitle']] = [];
            this.categories[element['categoryTitle']].push(element);
          }
        });
      },
    },
  };
</script>

<style>
  .topic-title {
    display: inline;
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.25px;
    text-decoration-line: underline;
    color: #0060aa;
  }

  .topic-category-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.5px;
    color: #383838;
    padding: 0.5rem;
  }

  .support-header {
    font-weight: 400;
    font-size: 24px;
    line-height: 33px;
    /* identical to box height */
    letter-spacing: 0.208333px;
    color: #383838;
    margin-top: 2.5rem;
    margin-bottom: 1rem;
  }

  .textarea-style {
    background: rgb(255, 255, 255);
    border: 1px solid rgb(231, 224, 236);
    box-sizing: border-box;
    border-radius: 8px;
    height: 196px;
    margin-top: 1rem;
    padding: 1rem;
  }
</style>
